module.exports = __webpack_public_path__ + "static/media/list.f1933da0.svg";